const HeaderClub = ({
  name,
  place,
  address,
  img,
  openHours,
  weekday,
  courts,
  captain,
  subcaptain
}) => {
  return (
    <div className="flex items-center justify-center bg-blue flex-col lg:flex-row">
      <div className="mt-5 lg:my-10 lg:mr-16">
        <div className="group relative w-28 h-28 lg:w-[250px] lg:h-[250px] rounded-full overflow-hidden bg-sec-grey-1">
          <img src={img} className="object-cover w-full h-full" />
        </div>
      </div>
      <div className="mb-5 lg:ml-12 lg:mb-20 mx-4 lg:mx-0">
        <p className="pb-6 mt-6 text-white text-3xl lg:text-[48px] leading-tight text-center lg:text-left">
          {name}
        </p>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 lg:gap-x-0 max-w-[900px]">
          <div className="lg:pt-4 leading-tight lg:mr-6">
            <p className="text-accent font-alliance-light text-[16px] lg:text pt-2 lg:-[20px]">
              Seu:
            </p>
            <p className="text-white font-alliance-medium text-[16px] lg:text-[20px]">
              {place}
            </p>
          </div>
          <div className="lg:pt-4 leading-tight lg:mx-6">
            <p className="text-accent font-alliance-light text-[16px] lg:text pt-2 lg:-[20px]">
              Direcció:
            </p>
            <p className="text-white font-alliance-medium text-[16px] lg:text-[20px]">
              {address}
            </p>
          </div>
          <div className="pt-3 lg:pt-4 leading-tight lg:mx-6">
            <p className="text-accent font-alliance-light text-[16px] lg:text pt-2 lg:-[20px]">
              Pistes:
            </p>
            <p className="text-white font-alliance-medium text-[16px] lg:text-[20px]">
              {courts}
            </p>
          </div>

          <div className="pt-2 lg:pt-8 leading-tight lg:mr-6">
            <p className="text-accent font-alliance-light text-[16px] lg:text pt-2 lg:-[20px]">
              Horaris:
            </p>
            <p className="text-white font-alliance-medium text-[16px] lg:text-[20px]">
              {openHours}
            </p>
          </div>
          <div className="pt-2 lg:pt-8 leading-tight lg:mx-6">
            <p className="text-accent font-alliance-light text-[16px] lg:text pt-2 lg:-[20px]">
              Dia de joc:
            </p>
            <p className="text-white font-alliance-medium text-[16px] lg:text-[20px]">
              {weekday}
            </p>
          </div>
          <div className="pt-2 lg:pt-8 leading-tight lg:mx-6">
            <p className="text-accent font-alliance-light text-[16px] lg:text pt-2 lg:-[20px]">
              Capità/na:
            </p>
            <p className="text-white font-alliance-medium text-[16px] lg:text-[20px]">
              {captain}
            </p>
          </div>
          {subcaptain && (
            <div className="pt-2 lg:pt-8 leading-tight lg:mr-6">
              <p className="text-accent font-alliance-light text-[16px] lg:text pt-2 lg:-[20px]">
                Subcapità/na:
              </p>
              <p className="text-white font-alliance-medium text-[16px] lg:text-[20px]">
                {subcaptain}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default HeaderClub
